import {gql} from '@apollo/client';

import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllRunSchemasQuery} from './__generated/AllRunSchemasQuery';

export const ALL_RUN_SCHEMAS_QUERY = gql`
  query AllRunSchemasQuery @skipAudit @engComponent(name: RESULTS) {
    runSchemas {
      ...RunSchemaGraphQL
    }
  }
  ${getFragmentWrapper('RunSchema').fragment}
`;

export const useAllRunSchemasQuery = (): BenchlingQueryResult<AllRunSchemasQuery> =>
  useBenchlingQuery<AllRunSchemasQuery>(ALL_RUN_SCHEMAS_QUERY);
